import { render } from "./AccordionContent.vue?vue&type=template&id=ed9ad750&ts=true"
import script from "./AccordionContent.vue?vue&type=script&lang=ts"
export * from "./AccordionContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__